import { toIbanCategories } from '@pbk/utils';
export const formatAccountNumberFromIban = (iban) => {
    const categories = toIbanCategories(iban);
    if (!categories)
        return '';
    const isSortCodeEmpty = categories.sortCode
        .split('')
        .every((char) => char === '0');
    if (isSortCodeEmpty) {
        return `${categories.accountNumber} / ${categories.bankCode}`;
    }
    return `${categories.sortCode} - ${categories.accountNumber} / ${categories.bankCode}`;
};
